var _classCallCheck = require("/Users/qw/WebstormProjects/jwc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/qw/WebstormProjects/jwc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _require = require('./dataType'),
    isString = _require.isString;

var Error = require('./error');

var pointer =
/*#__PURE__*/
function () {
  "use strict";

  function Pointer(tableName) {
    _classCallCheck(this, Pointer);

    if (!isString(tableName)) {
      throw new Error(415);
    }

    this.tableName = tableName;
  }

  _createClass(Pointer, [{
    key: "set",
    value: function set(objectId) {
      if (!isString(objectId)) {
        throw new Error(415);
      }

      return {
        '__type': 'Pointer',
        'className': this.tableName,
        'objectId': objectId
      };
    }
  }]);

  return Pointer;
}();

module.exports = pointer;